import React, { useState, useEffect, useRef } from 'react'
import './page.css'
import { Container, Row, Col, Card } from 'react-bootstrap';
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { MdAccessTime } from "react-icons/md";
import { GoDotFill } from "react-icons/go";
import { CiMail } from "react-icons/ci";
import { FaWhatsapp } from "react-icons/fa";
import LocalIP from "../../LocalIP"
import axios from "axios"

const Refund = () => {

  return (
    <>
      <div id="refund" className="bg-light">
        <section className="refund-policy-page">
          <div className="policy-header">
            <div className="container">
              <h1>
                <AiOutlineExclamationCircle />&nbsp;Refund Policy
              </h1>
              <p className='text-start px-4'>
                Thank you for choosing CodeFlex. We take pride in providing high-quality IT and software development services.
              </p>
            </div>
          </div>

          <div className="container pb-5">
            <div className="alert-box">
              <div className="alert-box-header">
                <h3><AiOutlineExclamationCircle />&nbsp;Please Read Carefully</h3>
              </div>
              <p className='text-start px-4'>
                Please review our Refund Policy carefully before making any payments. All projects operate on an advance payment basis.
              </p>
            </div>

            <div className="policy-section text-start">
              <div className="section-title-bordered">
                <h2>Payments and Refunds</h2>
              </div>
              <p className="section-description px-1">
                All our projects and services operate on a structured payment basis. Work begins only after receipt of the agreed advance amount, and final deliverables are provided after full payment is completed.
              </p>

              <div className="sub-section sub-section-blue">
                <h3>Advance Payment</h3>
                <p>
                  Once the advance payment is made, it is non-refundable, as it covers initial planning, resource allocation, and project initiation costs.
                </p>
              </div>

              <div className="sub-section sub-section-green">
                <h3>Balance Payment</h3>
                <p>
                  The remaining balance must be paid in full before the delivery of the final project files, code, or any other deliverables.
No work proof, source code, or final materials will be released until the balance payment is received.
                </p>
              </div>

              <div className="warning-alert">
                <i className="bi bi-exclamation-triangle-fill"></i>
                <p>No work proof, source code, or final deliverables will be released until full payment is received.</p>
              </div>
            </div>

            {/* Project Cancellation Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered">
                <h2>Project Cancellation</h2>
              </div>

              <div className="info-box neutral">
                <i className="bi bi-x-circle"></i>
                <div className="info-box-content">
                  <p>
                    <IoIosCloseCircleOutline />&nbsp;If a project is cancelled <strong>before any work has started</strong>, a partial refund may be issued after deducting administrative or transaction fees.
                  </p>
                </div>
              </div>

              <div className="info-box warning">
                <i className="bi bi-x-circle-fill"></i>
                <div className="info-box-content">
                  <p>
                    <IoIosCloseCircleOutline />&nbsp;If work has <strong>already commenced</strong>, the advance payment will be forfeited to cover development time and resource costs.
                  </p>
                </div>
              </div>
            </div>

            {/* Service-Based Projects Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered purple">
                <h2>Service-Based Projects</h2>
              </div>
              <p className="section-description px-1">
                For ongoing or milestone-based services:
              </p>

              <div className="service-card purple">
                <i className="bi bi-check-circle"></i>
                <div className="service-card-content">
                  <h3><IoMdCheckmarkCircleOutline /><br /><br />Refund Eligibility</h3>
                  <p>Refunds may be issued only for uninitiated phases of the project.</p>
                </div>
              </div>

              <div className="service-card blue">
                <i className="bi bi-clock"></i>
                <div className="service-card-content">
                  <h3><MdAccessTime /><br /><br />Completed Work</h3>
                  <p>Work completed up to the cancellation date will be billed in full.</p>
                </div>
              </div>
            </div>

            {/* Exceptions Section */}
            <div className="policy-section text-start">
              <div className="section-title-bordered green">
                <h2>Exceptions</h2>
              </div>
              <p className="section-description px-1">
                Refunds may be considered only in exceptional cases such as:
              </p>

              <ul className="exception-list">
                <li className="exception-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <p><GoDotFill />&nbsp;Duplicate payments made in error.</p>
                </li>
                <li className="exception-item">
                  <i className="bi bi-check-circle-fill"></i>
                  <p><GoDotFill />&nbsp;Failure by CodeFlex to commence any work due to unforeseen internal reasons.</p>
                </li>
              </ul>
            </div>

            {/* Processing Time Section */}
            <div className="processing-section text-start">
              <i className="bi bi-clock-history"></i>
              <div className="processing-content">
                <h2>Processing Time</h2>
                <p>Approved refunds will be processed within 7-10 business days via the original payment method.</p>
              </div>
            </div>

            {/* Contact Section */}
            <div className="contact-section text-start">
              <i className="bi bi-envelope-fill main-icon"></i>
              <h2><CiMail />&nbsp;Contact Us</h2>
              <div className='px-5'>
                <p>If you have questions about our refund process, please contact:</p>
                <a href="mailto:support@codeflexofficial.com" className="contact-email-btn">
                  support@codeflexofficial.com
                </a>
                <br/><br/>
                <a
                  href="https://wa.me/94712129185"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-email-btn"
                  style={{ color: "#25D366" }}
                >
                  <FaWhatsapp />&nbsp;+94 71 21 29 185
                </a>
              </div>
            </div>

            <div className="text-center mt-4">
              <p style={{ color: '#64748b', fontSize: '0.9rem' }}>
                Last Updated: October 13, 2025
              </p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Refund;
